<template>
    <li>
        <div class="title"><span>セールス募集</span></div>
        <div class="detail ">
            <div class="group form_checkbox">
                <div class="md_label">
                    <span>BtoB</span>
                </div>
                <input type="checkbox" name="sales-check1" class="" id="sales-check1-1" value="">
                <label for="sales-check1-1">
                    <div class="check-mark"><span></span></div>
                    <span>ショップ</span>
                </label>
                <input type="checkbox" name="sales-check1" class="" id="sales-check1-2" value="">
                <label for="sales-check1-2">
                    <div class="check-mark"><span></span></div>
                    <span>フランチャイズ</span>
                </label>
                <input type="checkbox" name="sales-check1" class="" id="sales-check1-3" value="">
                <label for="sales-check1-3">
                    <div class="check-mark"><span></span></div>
                    <span>販売代行</span>
                </label>
                <input type="checkbox" name="sales-check1" class="" id="sales-check1-4" value="">
                <label for="sales-check1-4">
                    <div class="check-mark"><span></span></div>
                    <span>営業代行</span>
                </label>
                <input type="checkbox" name="sales-check1" class="" id="sales-check1-5" value="">
                <label for="sales-check1-5">
                    <div class="check-mark"><span></span></div>
                    <span>ショールーム</span>
                </label>
                <input type="checkbox" name="sales-check1" class="" id="sales-check1-6" value="">
                <label for="sales-check1-6">
                    <div class="check-mark"><span></span></div>
                    <span>その他</span>
                </label>
            </div>
            <div class="group form_checkbox">
                <div class="md_label">
                    <span>BtoC</span>
                </div>
                <input type="checkbox" name="sales-check2" class="" id="sales-check2-1" value="">
                <label for="sales-check2-1">
                    <div class="check-mark"><span></span></div>
                    <span>ショップ</span>
                </label>
                <input type="checkbox" name="sales-check2" class="" id="sales-check2-2" value="">
                <label for="sales-check2-2">
                    <div class="check-mark"><span></span></div>
                    <span>フランチャイズ</span>
                </label>
                <input type="checkbox" name="sales-check2" class="" id="sales-check2-3" value="">
                <label for="sales-check2-3">
                    <div class="check-mark"><span></span></div>
                    <span>販売代行</span>
                </label>
                <input type="checkbox" name="sales-check2" class="" id="sales-check2-4" value="">
                <label for="sales-check2-4">
                    <div class="check-mark"><span></span></div>
                    <span>営業代行</span>
                </label>
                <input type="checkbox" name="sales-check2" class="" id="sales-check2-5" value="">
                <label for="sales-check2-5">
                    <div class="check-mark"><span></span></div>
                    <span>ショールーム</span>
                </label>
                <input type="checkbox" name="sales-check2" class="" id="sales-check2-6" value="">
                <label for="sales-check2-6">
                    <div class="check-mark"><span></span></div>
                    <span>その他</span>
                </label>
            </div>
        </div>
    </li>
</template>